import { updateCropActionName, resetCropActionName } from "../actions/image-uploader";
const imageCrop = {
  aspect: 1,
};
const initialState = {
  showCrop: false,
  crop: imageCrop,
  fetchedInitial: false,
  fetchingInitial: false,
  initialOnLoads: 0,
};
const imageUploader = (state = initialState, action) => {
  switch (action.type) {
    case updateCropActionName:
      return { ...state, ...action.payload };
    case resetCropActionName:
      return initialState;
    default:
      return state;
  }
};
export default imageUploader;
